export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#111315] border-t border-[#00E5FF]/10 overflow-hidden">
      {/* Subtle glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(0,229,255,0.4), transparent)' }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-4 gap-12 mb-14">
          {/* Brand Column */}
          <div className="md:col-span-2 space-y-5">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/f95a8b76717595cf01b4b6f3a86af516.png"
                alt="Graystone AI"
                className="h-14 w-auto object-contain"
              />
            </div>

            <div className="space-y-1">
              <p
                className="text-[#F4F7F6] font-semibold text-base"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Intelligent Architecture. Effortless Flow.
              </p>
              <p
                className="text-[#7F8C8D] text-sm"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Building the digital backbone of your business.
              </p>
            </div>

            <p
              className="text-[#7F8C8D] text-sm leading-relaxed max-w-sm"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              We design automation infrastructure that eliminates repetitive operational work and restores clarity to growing businesses between $1M–$10M revenue.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-4 pt-2">
              {[
                { icon: 'ri-linkedin-box-line', label: 'LinkedIn' },
                { icon: 'ri-twitter-x-line', label: 'Twitter' },
                { icon: 'ri-mail-line', label: 'Email' },
              ].map(({ icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-[#7F8C8D]/20 text-[#7F8C8D] hover:border-[#00E5FF]/60 hover:text-[#00E5FF] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-5">
            <h4
              className="text-[#F4F7F6] font-semibold text-sm tracking-widest uppercase"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Navigation
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'How It Works', href: '#how-it-works' },
                { label: 'Services', href: '#services' },
                { label: 'Industries', href: '#industries' },
                { label: 'Meet Grayson', href: '#grayson' },
                { label: 'Schedule Consultation', href: '#contact' },
              ].map(({ label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(href); }}
                    className="text-[#7F8C8D] hover:text-[#00E5FF] text-sm transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div className="space-y-5">
            <h4
              className="text-[#F4F7F6] font-semibold text-sm tracking-widest uppercase"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Industries
            </h4>
            <ul className="space-y-3">
              {[
                'Financial Services',
                'Healthcare & Med Spas',
                'Clinical Practices',
                'Professional Services',
                'Real Estate',
              ].map((item) => (
                <li key={item}>
                  <span
                    className="text-[#7F8C8D] text-sm"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#7F8C8D]/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p
              className="text-[#7F8C8D] text-xs"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              &copy; {currentYear} Graystone AI. All rights reserved.
            </p>
            <p
              className="text-[#7F8C8D]/50 text-xs italic"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Orchestrated by Graystone AI.
            </p>
            <div className="flex items-center gap-6">
              {['Privacy Policy', 'Terms of Service'].map((item) => (
                <a
                  key={item}
                  href="#"
                  rel="nofollow"
                  className="text-[#7F8C8D] hover:text-[#00E5FF] text-xs transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
